import Factory from './utils/factory'

export default Factory({
  id: null,
  from: null,
  to: null,
  message: null,
  references: [],
})
